import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateGatewayApiResponse } from '../services/createGatewayService'

export interface CreateGatewayState {
  isLoading: boolean
  error: string | undefined
  data: CreateGatewayApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: CreateGatewayState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createGatewaySlice = createSlice({
  name: 'CreateGatewaySlice',
  initialState,
  reducers: {
    createGatewayLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createGatewayUpdateAction: (state, action: PayloadAction<{ data: CreateGatewayApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createGatewayErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  createGatewayLoadingAction,
  createGatewayUpdateAction,
  createGatewayErrorAction,
  reset
} = createGatewaySlice.actions

export default createGatewaySlice.reducer
